import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
  selector: 'app-offer-badge',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  template: `
    <div class="offer-badge" [@pulseAnimation]="'active'">
      <div class="icon-wrapper">
        <mat-icon>local_offer</mat-icon>
        <div class="pulse-ring"></div>
      </div>
      <span class="badge-text">LIMITED TIME OFFER</span>
    </div>
  `,
  styles: [`
    .offer-badge {
      display: inline-flex;
      align-items: center;
      gap: 0.75rem;
      background: rgba(255, 255, 255, 0.1);
      padding: 1rem 2rem;
      border-radius: 50px;
      backdrop-filter: blur(10px);
      border: 1px solid rgba(255, 255, 255, 0.2);
      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
      position: relative;
      overflow: hidden;
    }

    .icon-wrapper {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    mat-icon {
      color: var(--accent-color);
      position: relative;
      z-index: 2;
    }

    .pulse-ring {
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      background: rgba(255, 215, 0, 0.2);
      animation: pulse 2s infinite;
    }

    .badge-text {
      font-size: 1.25rem;
      font-weight: 600;
      letter-spacing: 1px;
      background: linear-gradient(135deg, #fff, #ffd700);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      position: relative;
      z-index: 1;
    }

    @keyframes pulse {
      0% {
        transform: scale(1);
        opacity: 1;
      }
      50% {
        transform: scale(1.5);
        opacity: 0;
      }
      100% {
        transform: scale(1);
        opacity: 1;
      }
    }
  `],
  animations: [
    trigger('pulseAnimation', [
      state('active', style({ transform: 'scale(1)' })),
      transition('void => active', [
        style({ transform: 'scale(0.8)', opacity: 0 }),
        animate('0.3s ease-out', style({ transform: 'scale(1.1)', opacity: 1 })),
        animate('0.2s ease-in', style({ transform: 'scale(1)' }))
      ])
    ])
  ]
})
export class OfferBadgeComponent {}